export default __webpack_public_path__ + "static/media/3a.95c210b5.png";